import React from "react";
import "~/css/Indicator.css";

interface IndicatorProps {
  characterIndex: number;
  maxIndex: number;
  className?: string;
}

const Indicator: React.FC<IndicatorProps> = ({ characterIndex, maxIndex, className }) => {
  if (!maxIndex || maxIndex <= 0) return null;

  // 1～maxIndex の範囲に補正
  const idx = Math.min(Math.max(0, characterIndex), maxIndex);

  return (
    <div className={["indicator-list", className].filter(Boolean).join(" ")} role="status">
      {Array.from({ length: maxIndex }, (_, i) => {
        const active = i === idx;
        return <span key={i} className={`dot ${active ? " active" : ""}`} />;
      })}
    </div>
  );
};

export default Indicator;
